import Navbar from '@/components/layout/menu-bar/Navbar';
import Sidebar from '@/components/layout/menu-bar/Sidebar';
import { useStore } from '@/hooks/useStore';
import { getTitlePage } from '@/utils/routes';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default observer(function AdminPanelLayout() {
    // hooks
    const { pathname } = useLocation();

    // variables
    const title = getTitlePage(pathname);

    // store
    const {
        uiStore: { isOpenSidebar },
        authStore: { getProfile }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getProfile();
    }, [pathname]);

    return (
        <>
            <Sidebar />
            <main
                className={cn(
                    'bg-zinc-50 transition-[margin-left] ease-in-out duration-300',
                    isOpenSidebar === false ? 'lg:ml-[90px]' : 'lg:ml-[19rem]'
                )}
            >
                <Navbar title={title} />
                <div className=''>
                    <div className='bg-background-2 text-card-foreground px-4 pt-4 pb-0 min-h-[calc(100vh-56px)]'>
                        <Outlet />
                    </div>
                </div>
            </main>
        </>
    );
});
